var map = {
	"./ic_East_Timor.svg": 709,
	"./ic_Rapa_Nui.svg": 710,
	"./ic_abkhazia.svg": 711,
	"./ic_afghanistan.svg": 712,
	"./ic_aland_islands.svg": 713,
	"./ic_albania.svg": 714,
	"./ic_algeria.svg": 715,
	"./ic_american_samoa.svg": 716,
	"./ic_andorra.svg": 717,
	"./ic_angola.svg": 718,
	"./ic_anguilla.svg": 719,
	"./ic_antigua_and_barbuda.svg": 720,
	"./ic_argentina.svg": 721,
	"./ic_armenia.svg": 722,
	"./ic_aruba.svg": 723,
	"./ic_australia.svg": 724,
	"./ic_austria.svg": 725,
	"./ic_azerbaijan.svg": 726,
	"./ic_azores_islands.svg": 727,
	"./ic_bahamas.svg": 728,
	"./ic_bahrain.svg": 729,
	"./ic_balearic_islands.svg": 730,
	"./ic_bangladesh.svg": 731,
	"./ic_barbados.svg": 732,
	"./ic_basque_country.svg": 733,
	"./ic_belarus.svg": 734,
	"./ic_belgium.svg": 735,
	"./ic_belize.svg": 736,
	"./ic_benin.svg": 737,
	"./ic_bermuda.svg": 738,
	"./ic_bhutan.svg": 739,
	"./ic_bolivia.svg": 740,
	"./ic_bonaire.svg": 741,
	"./ic_bosnia_and_herzegovina.svg": 742,
	"./ic_botswana.svg": 743,
	"./ic_brazil.svg": 744,
	"./ic_british_columbia.svg": 745,
	"./ic_british_indian_ocean_territory.svg": 746,
	"./ic_british_virgin_islands.svg": 747,
	"./ic_brunei.svg": 748,
	"./ic_bulgaria.svg": 749,
	"./ic_burkina_faso.svg": 750,
	"./ic_burundi.svg": 751,
	"./ic_cambodia.svg": 752,
	"./ic_cameroon.svg": 753,
	"./ic_canada.svg": 754,
	"./ic_canary_islands.svg": 755,
	"./ic_cape_verde.svg": 756,
	"./ic_cayman_islands.svg": 757,
	"./ic_central_african_republic.svg": 758,
	"./ic_ceuta.svg": 759,
	"./ic_chad.svg": 760,
	"./ic_chile.svg": 761,
	"./ic_china.svg": 762,
	"./ic_cocos_island.svg": 763,
	"./ic_colombia.svg": 764,
	"./ic_comoros.svg": 765,
	"./ic_cook_islands.svg": 766,
	"./ic_corsica.svg": 767,
	"./ic_costa_rica.svg": 768,
	"./ic_croatia.svg": 769,
	"./ic_cuba.svg": 770,
	"./ic_curacao.svg": 771,
	"./ic_cyprus.svg": 772,
	"./ic_czech_republic.svg": 773,
	"./ic_democratic_republic_of_congo.svg": 774,
	"./ic_denmark.svg": 775,
	"./ic_djibouti.svg": 776,
	"./ic_dominica.svg": 777,
	"./ic_dominican_republic.svg": 778,
	"./ic_ecuador.svg": 779,
	"./ic_egypt.svg": 780,
	"./ic_el_salvador.svg": 781,
	"./ic_england.svg": 782,
	"./ic_equatorial_guinea.svg": 783,
	"./ic_eritrea.svg": 784,
	"./ic_estonia.svg": 785,
	"./ic_ethiopia.svg": 786,
	"./ic_european_union.svg": 787,
	"./ic_falkland_islands.svg": 788,
	"./ic_faroe_islands.svg": 789,
	"./ic_fiji.svg": 790,
	"./ic_finland.svg": 791,
	"./ic_france.svg": 792,
	"./ic_french_polynesia.svg": 793,
	"./ic_gabon.svg": 794,
	"./ic_galapagos_islands.svg": 795,
	"./ic_gambia.svg": 796,
	"./ic_georgia.svg": 797,
	"./ic_germany.svg": 798,
	"./ic_ghana.svg": 799,
	"./ic_gibraltar.svg": 800,
	"./ic_greece.svg": 801,
	"./ic_greenland.svg": 802,
	"./ic_grenada.svg": 803,
	"./ic_guam.svg": 804,
	"./ic_guatemala.svg": 805,
	"./ic_guernsey.svg": 806,
	"./ic_guinea.svg": 807,
	"./ic_guinea_bissau.svg": 808,
	"./ic_guyana.svg": 809,
	"./ic_haiti.svg": 810,
	"./ic_hawaii.svg": 811,
	"./ic_honduras.svg": 812,
	"./ic_hong_kong.svg": 813,
	"./ic_hungary.svg": 814,
	"./ic_iceland.svg": 815,
	"./ic_india.svg": 816,
	"./ic_indonesia.svg": 817,
	"./ic_iran.svg": 818,
	"./ic_iraq.svg": 819,
	"./ic_ireland.svg": 820,
	"./ic_isle_of_man.svg": 821,
	"./ic_israel.svg": 822,
	"./ic_italy.svg": 823,
	"./ic_ivory_coast.svg": 824,
	"./ic_jamaica.svg": 825,
	"./ic_japan.svg": 826,
	"./ic_jersey.svg": 827,
	"./ic_jordan.svg": 828,
	"./ic_kazakhstan.svg": 829,
	"./ic_kenya.svg": 830,
	"./ic_kiribati.svg": 831,
	"./ic_kosovo.svg": 832,
	"./ic_kuwait.svg": 833,
	"./ic_kyrgyzstan.svg": 834,
	"./ic_laos.svg": 835,
	"./ic_latvia.svg": 836,
	"./ic_lebanon.svg": 837,
	"./ic_lesotho.svg": 838,
	"./ic_liberia.svg": 839,
	"./ic_libya.svg": 840,
	"./ic_liechtenstein.svg": 841,
	"./ic_lithuania.svg": 842,
	"./ic_luxembourg.svg": 843,
	"./ic_macao.svg": 844,
	"./ic_madagascar.svg": 845,
	"./ic_madeira.svg": 846,
	"./ic_malawi.svg": 847,
	"./ic_malaysia.svg": 848,
	"./ic_maldives.svg": 849,
	"./ic_mali.svg": 850,
	"./ic_malta.svg": 851,
	"./ic_marshall_island.svg": 852,
	"./ic_martinique.svg": 853,
	"./ic_mauritania.svg": 854,
	"./ic_mauritius.svg": 855,
	"./ic_melilla.svg": 856,
	"./ic_mexico.svg": 857,
	"./ic_micronesia.svg": 858,
	"./ic_moldova.svg": 859,
	"./ic_monaco.svg": 860,
	"./ic_mongolia.svg": 861,
	"./ic_montenegro.svg": 862,
	"./ic_montserrat.svg": 863,
	"./ic_morocco.svg": 864,
	"./ic_mozambique.svg": 865,
	"./ic_myanmar.svg": 866,
	"./ic_namibia.svg": 867,
	"./ic_nato.svg": 868,
	"./ic_nauru.svg": 869,
	"./ic_nepal.svg": 870,
	"./ic_netherlands.svg": 871,
	"./ic_new_zealand.svg": 872,
	"./ic_nicaragua.svg": 873,
	"./ic_niger.svg": 874,
	"./ic_nigeria.svg": 875,
	"./ic_niue.svg": 876,
	"./ic_norfolk_island.svg": 877,
	"./ic_north_korea.svg": 878,
	"./ic_northern_cyprus.svg": 879,
	"./ic_northern_marianas_islands.svg": 880,
	"./ic_norway.svg": 881,
	"./ic_oman.svg": 882,
	"./ic_orkney_islands.svg": 883,
	"./ic_ossetia.svg": 884,
	"./ic_pakistan.svg": 885,
	"./ic_palau.svg": 886,
	"./ic_palestine.svg": 887,
	"./ic_panama.svg": 888,
	"./ic_papua_new_guinea.svg": 889,
	"./ic_paraguay.svg": 890,
	"./ic_peru.svg": 891,
	"./ic_philippines.svg": 892,
	"./ic_pitcairn_islands.svg": 893,
	"./ic_poland.svg": 894,
	"./ic_portugal.svg": 895,
	"./ic_puerto_rico.svg": 896,
	"./ic_qatar.svg": 897,
	"./ic_republic_of_macedonia.svg": 898,
	"./ic_republic_of_the_congo.svg": 899,
	"./ic_romania.svg": 900,
	"./ic_russia.svg": 901,
	"./ic_rwanda.svg": 902,
	"./ic_saba_island.svg": 903,
	"./ic_sahrawi_arab_democratic_republic.svg": 904,
	"./ic_samoa.svg": 905,
	"./ic_san_marino.svg": 906,
	"./ic_sao_tome_and_prince.svg": 907,
	"./ic_sardinia.svg": 908,
	"./ic_saudi_arabia.svg": 909,
	"./ic_scotland.svg": 910,
	"./ic_senegal.svg": 911,
	"./ic_serbia.svg": 912,
	"./ic_seychelles.svg": 913,
	"./ic_sierra_leone.svg": 914,
	"./ic_singapore.svg": 915,
	"./ic_sint_eustatius.svg": 916,
	"./ic_sint_maarten.svg": 917,
	"./ic_slovakia.svg": 918,
	"./ic_slovenia.svg": 919,
	"./ic_solomon_islands.svg": 920,
	"./ic_somalia.svg": 921,
	"./ic_somaliland.svg": 922,
	"./ic_south_africa.svg": 923,
	"./ic_south_korea.svg": 924,
	"./ic_south_sudan.svg": 925,
	"./ic_spain.svg": 926,
	"./ic_sri_lanka.svg": 927,
	"./ic_st_barts.svg": 928,
	"./ic_st_lucia.svg": 929,
	"./ic_st_vincent_and_the_grenadines.svg": 930,
	"./ic_sudan.svg": 931,
	"./ic_suriname.svg": 932,
	"./ic_swaziland.svg": 933,
	"./ic_sweden.svg": 934,
	"./ic_switzerland.svg": 935,
	"./ic_syria.svg": 936,
	"./ic_taiwan.svg": 937,
	"./ic_tajikistan.svg": 938,
	"./ic_tanzania.svg": 939,
	"./ic_thailand.svg": 940,
	"./ic_tibet.svg": 941,
	"./ic_togo.svg": 942,
	"./ic_tokelau.svg": 943,
	"./ic_tonga.svg": 944,
	"./ic_transnistria.svg": 945,
	"./ic_trinidad_and_tobago.svg": 946,
	"./ic_tunisia.svg": 947,
	"./ic_turkey.svg": 948,
	"./ic_turkmenistan.svg": 949,
	"./ic_turks_and_caicos.svg": 950,
	"./ic_tuvalu.svg": 951,
	"./ic_uganda.svg": 952,
	"./ic_ukraine.svg": 953,
	"./ic_united_arab_emirates.svg": 954,
	"./ic_united_kingdom.svg": 955,
	"./ic_united_nations.svg": 956,
	"./ic_united_states.svg": 957,
	"./ic_uruguay.svg": 958,
	"./ic_uzbekistán.svg": 959,
	"./ic_vanuatu.svg": 960,
	"./ic_vatican_city.svg": 961,
	"./ic_venezuela.svg": 962,
	"./ic_vietnam.svg": 963,
	"./ic_virgin_islands.svg": 964,
	"./ic_wales.svg": 965,
	"./ic_yemen.svg": 966,
	"./ic_zambia.svg": 967,
	"./ic_zimbabwe.svg": 968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 449;